import React from 'react';
import { connect } from 'react-redux';
import { eventLabelAction } from '../../store/actions/core/eventLabel.action';
import { store } from '../../store/configureStore'

//state

let labelSettings = {
    eventId: null,
    langCode: null
}
const creationList = {};

export function init(eventId, groupName, langCode) {
    labelSettings.eventId = eventId;
    labelSettings.langCode = langCode;

    store.dispatch(eventLabelAction.getGroup(eventId, groupName.toUpperCase(), langCode))
}

function create(name, groupName) {
    if (!creationList[groupName] || !creationList[groupName].includes(name)) {
        if (!creationList[groupName]) {
            creationList[groupName] = [];
        }
        creationList[groupName].push(name);
    }
    const { langCode, eventId } = labelSettings;
    store.dispatch(eventLabelAction.create(eventId, name, groupName.toUpperCase(), langCode))
}

export function renderText(name, groupName) {
    if (!name || !groupName) return;
    let n = name.toUpperCase();
    let g = groupName.toUpperCase();
    const groups = store.getState().eventLabel.groups;
    let group = groups[g];

    if (!group) {
        return `*${name}*`;
    }
    else if (!Array.isArray(group) && group.loading) {
        return `*${name}*`;
    }
    else if (!group.find(g => g.name == n)) {
        create(name, groupName);
        return `*${name}*`;
    }
    else {
        return group.find(g => g.name == n).value;
    }
}

class EventLabel2 extends React.Component {
    getFromGroup = () => {
        const { groups, name, groupName } = this.props;
        if (!name || !groupName) return;
        let n = name.toUpperCase();
        let g = groupName.toUpperCase();
        let group = groups[g];

        if (!group) {
            return `*${name}*`;
        }
        else if (!Array.isArray(group) && group.loading) {
            return `*${name}*`;
        }
        else if (!group.find(g => g.name == n)) {
            create(name, groupName);
            return `*${name}*`;
        }
        else {
            return group.find(g => g.name == n).value;
        }
    }
    render() {
        let text = this.getFromGroup();
        return <span>{text}</span>
    }
}

function mapStateToProps(state) {
    return {
        groups: state.eventLabel.groups,
        loading: state.eventLabel.loading,
        error: state.eventLabel.error

    };
}
export default connect(mapStateToProps)(EventLabel2);